import { comMapping } from '@/components/util/Function/comMapping';

export function getdata() {
    var obj = {
        formlist: [
            {
                prop: 'bsType',
                label: '业务专项',
                type: 'select',
                width: '130px',
                selectval: comMapping.$ywzx,
                disabled: true
            },
            {
                prop: 'bsName',
                label: '业务名称',
                type: 'input',
                width: '130px'
            },
            {
                prop: 'resRange',
                label: '取值范围',
                type: 'select',
                width: '130px',
                selectval: comMapping.$qzfw
            },
            {
                prop: 'code',
                label: '业务代码',
                type: 'input',
                width: '130px',
                disabled: true
            }
        ],
        ruleForm: {},
        formdata: {
            bsType: '',
            resRange: '',
            bsName: '',
            code: ''
        },
        rules: {
            resRange: [
                { required: true, message: '请选择取值范围', trigger: 'blur' }
            ],
            bsName: [
                { required: true, message: '请输入业务名称', trigger: 'blur' }
            ]
        }
    };
    return obj;
}
